import bridge from '../bridge'
import { noop } from '../util/lang'
import env from '../core/env'
import { ajax } from '../core/ajax'
import { weixinReady, alipayReady, alipayMpReady, qqReady } from '../outsdk'

function resHandler (ret) {
  return { latitude: ret.latitude, longitude: ret.longitude, lat: ret.latitude, lng: ret.longitude }
}

function getLocationInfo (option = {}, callback = noop) {
  if (typeof option === 'function') {
    callback = option
    option = {}
  }
  if (env.is('passenger,driver')) {
    bridge.getLocationInfo(option, function (res) {
      callback({
        errno: 0,
        errmsg: 'success',
        lat: res.lat,
        lng: res.lng,
        cityId: res.cityId || res.city_id,
        area: res.area
      })
    })
  } else {
    if (env.is('weixin')) {
      weixinReady(sdk => {
        if (sdk && sdk.getLocation) {
          sdk.getLocation({
            success: (ret) => {
              getCityInfo(resHandler(ret), callback)
            },
            cancel: (res) => {
              callback({
                errno: -1,
                errmsg: res.errorMessage
              })
            }
          })
        } else {
          callback({ errno: -1, errmsg: '微信sdk加载异常' })
        }
      })
    } else if (env.is('alipay.miniprogram')) {
      alipayMpReady(sdk => {
        if (sdk && sdk.getLocation) {
          sdk.getLocation({
            success: (ret) => {
              getCityInfo(resHandler(ret), callback)
            },
            fail: (res) => {
              callback({
                errno: -1,
                errmsg: '定位失败'
              })
            }
          })
        } else {
          callback({ errno: -1, errmsg: '支付宝sdk加载异常' })
        }
      })
    } else if (env.is('alipay')) {
      alipayReady(sdk => {
        sdk.call('getLocation', result => {
          if (result.error) {
            callback({
              errno: -1,
              errmsg: result.errorMessage
            })
          } else {
            getCityInfo(resHandler(result), callback)
          }
        })
      })
    } else if (env.is('mqq')) {
      qqReady(sdk => {
        if (sdk && sdk.sensor.getLocation) {
          sdk.sensor.getLocation({}, (retCode, latitude, longitude) => {
            getCityInfo(resHandler({latitude, longitude}), callback)
          })
        } else {
          callback({
            errno: -1,
            errmsg: 'qqsdk加载异常'
          })
        }
      })
    } else if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          // Coordinates
          getCityInfo(resHandler(position.coords), callback)
        },
        function (err) {
          callback({
            errno: -1,
            errmsg: '获取定位失败'
          })
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      )
    } else {
      callback({
        errno: -1,
        errmsg: '您的浏览器不支持定位'
      })
    }
  }
}

function getCityInfo (opts, cb) {
  let api = '//common.diditaxi.com.cn/webcore/geo/reversegeotop'
  let lat = opts.latitude || opts.lat
  let lng = opts.longitude || opts.lng
  let data = {
    from_lat: lat || -1,
    from_lng: lng || -1
  }
  ajax({
    url: api,
    method: 'get',
    data: data,
    dataType: 'json',
    needEncrypt: true,
    success: function (res) {
      if (res.errno === 0) {
        cb({ errno: 0, errmsg: 'ok', cityId: res.data.cityid, lat: lat, lng: lng })
      } else {
        cb({ errno: -1, errmsg: '接口返回错误errno=' + res.errno, cityId: null, lat: lat, lng: lng })
      }
    },
    error: function () {
      cb({ errno: -1, errmsg: 'ajax error', cityId: null, lat: lat, lng: lng })
    }
  })
}

export default {
  getLocation: getLocationInfo,
  getLocationInfo,
  getCityInfo
}
